var _style, _defs, _defs2, _path, _path2, _defs3, _g, _defs4, _g2, _defs5, _g3, _path3, _defs6, _g4, _path4, _defs7, _g5, _defs8, _g6, _path5, _defs9, _g7, _path6, _defs10, _g8, _defs11, _g9, _defs12, _g10, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPiggy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000109717251125363877580000001697983262783651263_);}\n\t.st1{clip-path:url(#SVGID_00000166649786831341970790000005366978833452603313_);}\n\t.st2{fill:#FFC400;}\n\t.st3{fill:#FFD03B;}\n\t.st4{opacity:0.3;}\n\t.st5{clip-path:url(#SVGID_00000099659117422937749430000012702323537533565344_);}\n\t.st6{fill:#FEFCFD;}\n\t.st7{opacity:0.6;}\n\t.st8{clip-path:url(#SVGID_00000168078219466645581600000014966322376024699071_);}\n\t.st9{fill:#EF7213;}\n\t.st10{clip-path:url(#SVGID_00000093160048542966000850000012671017492711256209_);}\n\t.st11{fill:#E86061;}\n\t.st12{fill:#F8B397;}\n\t.st13{opacity:0.2;}\n\t.st14{clip-path:url(#SVGID_00000119109865784287652560000005990243806334133130_);}\n\t.st15{fill:#E75652;}\n\t.st16{opacity:0.5;}\n\t.st17{clip-path:url(#SVGID_00000147926760028077252060000008931023314710873476_);}\n\t.st18{clip-path:url(#SVGID_00000029744924562709325670000002953013164448758950_);}\n\t.st19{clip-path:url(#SVGID_00000108285125828898030490000012461193391463947656_);}\n\t.st20{clip-path:url(#SVGID_00000093176463994489856530000001337414482029767041_);}\n\t.st21{clip-path:url(#SVGID_00000034809942895926735170000011081755679595975332_);}\n\t.st22{clip-path:url(#SVGID_00000040543092723274967080000014360277124937678997_);}\n\t.st23{fill:#894E4A;}\n\t.st24{fill:none;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5026"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5023"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 4.3,
    y: 2.7,
    width: 15.3,
    height: 18.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000131334284613808842510000001868846752312796842_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000131334284613808842510000001868846752312796842_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5021"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000048499524762642403070000004582109947936046982_",
    x: 4.3,
    y: 2.7,
    width: 15.3,
    height: 18.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168811481006932935410000015621893479009146792_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000048499524762642403070000004582109947936046982_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000168811481006932935410000015621893479009146792_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5020"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9255",
    className: "st2",
    d: "M14.7,5c1,1.7,0.4,3.9-1.3,4.8s-3.9,0.4-4.8-1.3S8.1,4.6,9.8,3.7l0,0 C11.5,2.7,13.7,3.3,14.7,5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9256",
    className: "st3",
    d: "M11.6,10.8c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4c1.4,0,2.8,0.8,3.5,2l0,0 c1.1,1.9,0.4,4.4-1.5,5.5C13,10.6,12.3,10.8,11.6,10.8 M11.6,3.7C9.9,3.7,8.5,5,8.5,6.7s1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1 c0-0.5-0.1-1.1-0.4-1.5C13.7,4.2,12.7,3.7,11.6,3.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4992",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4991"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000106141476669850757010000015940469335688101530_",
    x: 8.6,
    y: 3.4,
    width: 6.1,
    height: 6.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000045607026843640613660000014776948738362745750_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106141476669850757010000015940469335688101530_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000045607026843640613660000014776948738362745750_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4990"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9257",
    className: "st6",
    d: "M8.6,9.1C9,9.6,9.6,10,10.2,10.3l4.6-5.7c-0.4-0.5-0.9-1-1.4-1.3 C13.3,3.4,8.6,9.1,8.6,9.1z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4995",
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4994"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000080169388125448209510000010324507503790159806_",
    x: 10.3,
    y: 5,
    width: 2.6,
    height: 3.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052085821303971165280000014567367703908995974_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080169388125448209510000010324507503790159806_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000052085821303971165280000014567367703908995974_)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9258",
    className: "st9",
    d: "M12.1,8.1c-0.2,0.1-0.4,0.1-0.6,0.2c-0.1,0-0.3,0-0.3-0.1 c0-0.1-0.1-0.2,0-0.2c0-0.1,0.1-0.2,0.2-0.2c0,0,0.1,0,0.1-0.1l0.2,0c0.1,0,0.1,0,0.2-0.1S12,7.5,12,7.5 c0.1,0,0.1-0.1,0.2-0.2s0-0.2,0-0.2C12.1,7,12.1,7,12,7c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0.1 C11.4,7,11.3,7,11.1,7c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.2-0.1-0.4-0.1-0.6 c0.1-0.2,0.2-0.4,0.4-0.6l-0.1-0.2c-0.1-0.1-0.1-0.2,0-0.3c0,0,0.1,0,0.1,0c0.1,0,0.1,0.1,0.1,0.1l0.1,0.2 c0.2-0.1,0.4-0.1,0.5-0.1c0.1,0,0.2,0.1,0.3,0.2c0,0.1,0.1,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.2c0,0-0.1,0-0.1,0.1l-0.1,0 c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0.1C11,5.9,11,6,10.9,6.1c0,0.1,0,0.1,0,0.2c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0 c0.1,0,0.1,0,0.2,0l0.2-0.1c0.2-0.1,0.5-0.1,0.7,0c0.2,0.1,0.4,0.2,0.4,0.4c0.1,0.1,0.1,0.2,0.1,0.3 c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.2,0.2-0.3,0.3l0.1,0.2c0.1,0.1,0.1,0.2,0,0.3c0,0-0.1,0-0.1,0 c-0.1,0-0.1-0.1-0.1-0.1L12.1,8.1L12.1,8.1z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4998",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4997"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000114773157392542182060000006126669937113113529_",
    x: 8.6,
    y: 8.8,
    width: 6.2,
    height: 1.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092437902921077549510000010613663701978170261_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114773157392542182060000006126669937113113529_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000092437902921077549510000010613663701978170261_)"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9259",
    className: "st11",
    d: "M13.7,8.8h-3.4c-0.6,0-1.2,0.1-1.8,0.3c1.3,1.7,3.7,1.9,5.4,0.7 c0.3-0.2,0.6-0.5,0.8-0.9C14.4,8.8,14.1,8.8,13.7,8.8"
  }))))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9260",
    className: "st12",
    d: "M4.3,13.3c0-0.4,0.4-0.8,0.8-0.8S6,12.9,6,13.3s-0.4,0.8-0.8,0.8l0,0 C4.7,14.1,4.3,13.8,4.3,13.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5001",
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5000"
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000073681266402440492360000018116368317921986976_",
    x: 4.3,
    y: 13.2,
    width: 1.5,
    height: 1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000035499185744044336910000005508092806333376908_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000073681266402440492360000018116368317921986976_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000035499185744044336910000005508092806333376908_)"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9261",
    className: "st15",
    d: "M5.9,13.7l-1.5-0.5C4.3,13.6,4.5,14,5,14.1C5.3,14.2,5.7,14,5.9,13.7"
  }))))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9262",
    className: "st12",
    d: "M19.7,15.9c0,0.4-0.4,0.8-0.8,0.8h-0.6c-0.4,0-0.3-0.4-0.3-0.8v-1.9 c0-0.4,0.1-0.8,0.5-0.8h0.3c0.4,0,0.8,0.4,0.8,0.8V15.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5004",
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5003"
  }, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000013176009713331636120000016429117020315892916_",
    x: 18,
    y: 13.7,
    width: 1.6,
    height: 0.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060742596760954521980000018341754481964353448_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013176009713331636120000016429117020315892916_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000060742596760954521980000018341754481964353448_)"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9263",
    className: "st6",
    d: "M18,13.9v0.3h1.6v-0.3c0-0.1,0-0.2-0.1-0.3H18C18,13.8,18,13.8,18,13.9"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5007",
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5006"
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000130629365531133578300000000167617681099739540_",
    x: 18,
    y: 14.8,
    width: 1.7,
    height: 1.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000169552196289428068170000013481419296892077756_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000130629365531133578300000000167617681099739540_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000169552196289428068170000013481419296892077756_)"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5005"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9264",
    className: "st15",
    d: "M18,14.8v1.1c0,0.4-0.2,0.8,0.3,0.8h0.6c0.4,0,0.8-0.4,0.8-0.8v-1.1 C19.7,14.8,18,14.8,18,14.8z"
  }))))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9265",
    className: "st12",
    d: "M13.7,9.2h-3.4c-2.8,0-5.1,2.3-5.1,5.1v0.1c0,1.6,0.8,3.1,2.1,4.1l-0.2,1.2 c-0.1,0.5,0.2,0.9,0.7,1c0.1,0,0.1,0,0.2,0h0.2c0.6,0,1.1-0.5,1.2-1l0-0.2c0.3,0,0.6,0.1,0.9,0.1h3.5l0,0.2 c0.1,0.6,0.6,1,1.2,1h0.2c0.5,0,0.9-0.4,0.9-0.9c0-0.1,0-0.1,0-0.2L16.1,19c1.7-0.9,2.8-2.6,2.8-4.5v-0.1 C18.8,11.6,16.5,9.3,13.7,9.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5010",
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5009"
  }, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000179617118949625067520000001431357449044018101_",
    x: 6.6,
    y: 9.8,
    width: 7.2,
    height: 2.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000025437737923759174430000003146592326088470186_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179617118949625067520000001431357449044018101_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000025437737923759174430000003146592326088470186_)"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5008"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9266",
    className: "st6",
    d: "M7,12.6c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0-0.1,0.1-0.2 c0.9-1.3,2.3-2.2,3.9-2.2h2.8c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4h-2.8c-1.3,0-2.5,0.7-3.2,1.8 C7.3,12.5,7.2,12.6,7,12.6"
  }))))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9267",
    className: "st12",
    d: "M14.6,9.8c-0.2-0.1-0.2-0.3,0.1-0.4l2.3-0.6c0.3-0.1,0.4,0.1,0.4,0.4l-0.4,1.4 c0,0.2-0.2,0.4-0.5,0.3c0,0-0.1,0-0.1-0.1L14.6,9.8L14.6,9.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5013",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5012"
  }, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000157997452348409979420000010116661738360782477_",
    x: 5.2,
    y: 14.4,
    width: 13.6,
    height: 6.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000166667981372312850910000003201233919297411746_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000157997452348409979420000010116661738360782477_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000166667981372312850910000003201233919297411746_)"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5011"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9268",
    className: "st15",
    d: "M18.8,14.4L18.8,14.4c0,2.1-2.5,3.8-4.5,3.8H9.8c-2,0-4.5-1.6-4.5-3.7v-0.1 h0v0.1c0,1.6,0.8,3.1,2.1,4.1l-0.2,1.2c-0.1,0.5,0.2,0.9,0.7,1c0.1,0,0.1,0,0.2,0h0.2c0.6,0,1.1-0.5,1.2-1l0-0.2 c0.3,0,0.6,0.1,0.9,0.1h3.5l0,0.2c0.1,0.6,0.6,1,1.2,1h0.2c0.5,0,0.9-0.4,0.9-0.9c0-0.1,0-0.1,0-0.2L16.1,19 C17.8,18.2,18.8,16.4,18.8,14.4L18.8,14.4L18.8,14.4L18.8,14.4z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5016",
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5015"
  }, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000150815945660516865550000010059529912771163022_",
    x: 16.1,
    y: 8.8,
    width: 1.2,
    height: 2.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000066473479273061878250000004288514125531904154_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150815945660516865550000010059529912771163022_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000066473479273061878250000004288514125531904154_)"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5014"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9269",
    className: "st15",
    d: "M17.2,8.8l-1.1,1.9l0.2,0.1c0.2,0.1,0.4,0.1,0.5-0.1c0,0,0-0.1,0.1-0.1 l0.4-1.4C17.3,9,17.3,8.9,17.2,8.8"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5019",
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5018"
  }, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000183971103262503636390000001662511149524582814_",
    x: 16.5,
    y: 12.5,
    width: 0.8,
    height: 0.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000025400331608899719490000003835820516348342413_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183971103262503636390000001662511149524582814_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000025400331608899719490000003835820516348342413_)"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5017"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9270",
    className: "st23",
    d: "M17.3,12.9c0,0.2-0.2,0.4-0.4,0.4s-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4 S17.3,12.7,17.3,12.9L17.3,12.9"
  })))))))))))))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    width: 24,
    height: 24
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggy);
export default __webpack_public_path__ + "static/media/piggy.42b2cab0cac88e9e641dcf4181aec0e0.svg";
export { ForwardRef as ReactComponent };